import { fromJS, is } from 'immutable'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'
import app from 'containers/app'
import * as EmbedActions from 'app/modules/embed/actions'
import * as EmbedSelectors from 'app/modules/embed/selectors'
import { fetchTimeZone } from 'app/api/TimeZoneAPI'
import Banner from './Banner.js'
import Information from './Information.js'
import InformationEdit from './InformationEdit.js'

import style from './style'
import colors from 'styles/colors'

class TitleCard extends Component {
  state = {
    editing: false,
    updating: false,
    endUser: fromJS(this.props.endUser),
  }

  static defaultProps = {
    editable: true,
    width: '100%',
  }

  componentWillMount() {
    this.props.actions.fetchEmbed()
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.updating && is(fromJS(nextProps.endUser), this.state.endUser)) {
      this.setState({ editing: false, updating: false, })
    }
  }

  handleNameChange = event => {
    this.setState({ endUser: this.state.endUser.set('name', event.target.value) })
  }

  handleLocationChange = async (suggestion) => {
    const { lat, lng } = suggestion.location
    const timezone = await fetchTimeZone(lat, lng)
    const city = suggestion.gmaps.address_components
      .find(component => component.types.find(type => type === 'locality'))
    const country = suggestion.gmaps.address_components
      .find(component => component.types.find(type => type === 'country'))
    this.setState({
      endUser: this.state.endUser
        .setIn(['attributes', 'display_location'], suggestion.label)
        .setIn(['attributes', 'latitude'], lat)
        .setIn(['attributes', 'longitude'], lng)
        .setIn(['attributes', 'city'], city.long_name)
        .setIn(['attributes', 'country'], country.long_name)
        .set('timeZone', timezone.timeZoneId)
    })
  }

  isChanged() {
    return !is(fromJS(this.props.endUser), this.state.endUser)
  }

  handleEdit = () => {
    this.setState({ editing: true })
  }

  handleCancel = () => {
    this.setState({
      endUser: fromJS(this.props.endUser),
      editing: false,
    })
  }

  handleSave = () => {
    if (!this.isChanged()) return
    app.queries.EndUserQueries.updateEndUser(
      this.props.endUser.id,
      this.state.endUser.toJS()
    )
    this.setState({ updating: true })
  }

  render() {
    const { endUser, editing, updating } = this.state
    const { defaultInboxId, width, editable, showTooltip, showProfileLink } = this.props

    const name = getDisplayName(this.state.endUser.toJS())
    const timeZone = endUser.get('timeZone')
    const displayLocation = endUser.getIn(['attributes', 'display_location'])
    const employmentTitle = endUser.getIn(['attributes', 'employment_title'])
    const longitude = endUser.getIn(['attributes', 'longitude'])
    const latitude = endUser.getIn(['attributes', 'latitude'])

    return (
      <div
        className={`dsg-card ${style.TitleCard}`}
        style={{
          width,
          background: colors['color-white'],
          marginBottom: '1rem',
        }}
      >
        <Banner
          longitude={longitude}
          latitude={latitude}
          displayLocation={displayLocation}
          editing={editing}
          updating={updating}
          editable={editable}
          handleEdit={this.handleEdit}
          handleSave={this.handleSave}
          handleCancel={this.handleCancel}
          changed={this.isChanged()}
          endUser={endUser.toJS()}
          timeZone={timeZone}
        />
        <div style={{ padding: '3px 14px 14px' }}>
          { editing
              ? <InformationEdit
                  name={name}
                  displayLocation={displayLocation}
                  handleSave={this.handleSave}
                  handleNameChange={this.handleNameChange}
                  handleLocationChange={this.handleLocationChange}
                />
              : <Information
                  showProfileLink={showProfileLink}
                  showTooltip={showTooltip}
                  employmentTitle={employmentTitle}
                  editable={editable}
                  endUser={this.props.endUser}
                  name={name}
                  inboxId={defaultInboxId}
                  handleEdit={editable && this.handleEdit}
                />
          }
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    defaultInboxId: EmbedSelectors.defaultInboxId(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchEmbed: EmbedActions.fetchEmbed
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TitleCard)



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TitleCard/index.js